import IIssuingAuthorityVm from "./IIssuingAuthorityVm"
import IUserVm from "./../shared/IUserVm"

import * as IUserVmInstance from "./../shared/IUserVm"
import * as IIssuingAuthorityVmInstance from "./IIssuingAuthorityVm"

export default interface ICaseworkerVm {
    id: string
    user: IUserVm
    issuingAuthority: IIssuingAuthorityVm
    name: string
    email: string
    phone: string
    isActive: boolean
    isAdministrative: boolean
}

export const empty = (enableIteration: boolean = true): ICaseworkerVm => {
	return {
		id: "",
		user: IUserVmInstance.empty(),
		issuingAuthority: IIssuingAuthorityVmInstance.empty(),
		name: "",
		email: "",
		phone: "",
		isActive: false,
		isAdministrative: false
	} as ICaseworkerVm
}